import { render } from "./MobileHalf.vue?vue&type=template&id=7cf7eef3"
import script from "./MobileHalf.vue?vue&type=script&lang=js"
export * from "./MobileHalf.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/amatra-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__